<template>
  <html lang="pt-br">
    <head>      
      <meta name="description" content="Artigos e Publicações">

      <component-head-style/>
    </head>

    <body class="body-wrapper" data-spy="scroll" data-target=".privacy-nav">
      <component-nav-bar/>

        <section class="section about p-0">
          <div class="container">
            <div class="row">
              <div class="col-lg-10 col-md-8 col-sm-12 mx-auto my-5">
                <div id="carouselIndicator" class="carousel slide" data-ride="carousel">
                  <ol class="carousel-indicators">
                    <li data-target="#carouselIndicator" data-slide-to="0" class="carousel-indicator active"></li>
                    <li data-target="#carouselIndicator" data-slide-to="1" class="carousel-indicator"></li>
                    <li data-target="#carouselIndicator" data-slide-to="2" class="carousel-indicator"></li>
                    <li data-target="#carouselIndicator" data-slide-to="2" class="carousel-indicator"></li>
                    <li data-target="#carouselIndicator" data-slide-to="2" class="carousel-indicator"></li>
                  </ol>

                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <a href="https://concurso.caarapo.ibcgp.org.br/" target="_blank">
                        <img src="../../assets/images/ibcgp/publications/publication-05/01.jpeg" class="carousel-image d-block w-100" alt="...">
                      </a>
                    </div>

                    <div class="carousel-item">
                      <img src="../../assets/images/ibcgp/publications/publication-05/02.jpeg" class="carousel-image d-block w-100" alt="...">
                    </div>

                    <div class="carousel-item">
                      <img src="../../assets/images/ibcgp/publications/publication-05/03.jpeg" class="carousel-image d-block w-100" alt="...">
                    </div>  

                    <div class="carousel-item">
                      <img src="../../assets/images/ibcgp/publications/publication-05/04.jpeg" class="carousel-image d-block w-100" alt="...">
                    </div>    

                    <div class="carousel-item">
                      <img src="../../assets/images/ibcgp/publications/publication-05/05.jpeg" class="carousel-image d-block w-100" alt="...">
                    </div>                
                  </div>

                  <a class="carousel-control-prev" href="#carouselIndicator" role="button" data-slide="prev">
                    <span class="carousel-arrow carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Anterior</span>
                  </a>
                  <a class="carousel-control-next" href="#carouselIndicator" role="button" data-slide="next">
                    <span class="carousel-arrow carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Próximo</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

      <section class="section cta-hire bg-gary">
        <contact/>
      </section>

      <component-footer/>

      <btn-to-top/>
    </body>

    <component-body-scripts/>
  </html>
</template>

<script>
  import Head from '../structure/Head.vue';
  import Navbar from '../structure/Navbar.vue';

  import Contact from '../contact/ShortcutContact.vue';

  import Footer from '../structure/Footer.vue';
  import BtnToTop from '../structure/BtnToTop.vue';
  import BodyScripts from '../structure/BodyScripts.vue';

  export default {
    created(){
      document.title = "IBCGP | Artigos e Publicações";
    },
    components:{
      'component-head-style'    : Head,
      'component-nav-bar'       : Navbar,

      'contact'                 : Contact,

      'component-footer'        : Footer,
      'btn-to-top'              : BtnToTop,
      'component-body-scripts'  : BodyScripts
    },
    beforeMount() {
      this.navPublications = true;
    }
  }
</script>

<style scoped>
  .carousel-item{
    padding: 15px;
    cursor: -webkit-grabbing;
  }

  .carousel-image {
    border-radius: 5%;
  }

  .carousel-indicators li{
      display: inline-block;
      width: 10px;
      height: 10px;
      margin: 1px;
      text-indent: -999px;
      cursor: pointer;
      background-color: #000 \9;
      background-color: rgba(0,0,0,0);
      border: 1px solid #fff;
      border-radius: 10px;
      margin: 2px;
      position: relative;
      top: 30px;
  }


  @media only screen and (max-width: 650px)
  {
    .carousel-item img{
      height: auto;
    }
  }

  .carousel-control-prev{
    left: -50px;
    margin: 0 -25px;
  }

  .carousel-control-next{
    right: -50px;
    margin: 0 -25px;
  }

  .carousel-arrow{
    background-color: #cdcdcd;
    border-radius: 50%;
  }

  .carousel-indicator{
    background-color: #cdcdcd !important;
  }
</style>